module.exports = __webpack_public_path__ + "img/laundryBag02.14bceaf4.jpg";